import { faChevronLeft, faChevronRight, faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { getGallerie, likeGallerie } from "../actions/gallerie";
import { getDomain, tempAlWait } from "../helpers";
import Alert from "../components/Alert";
import { connect } from "react-redux";
import imgBg from "../images/parc/IMG_4132.jpg";
import imgBg2 from "../images/parc/IMG_4579.jpg";

class Home extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        gallImgs: [],
        currentPlacementGallerie: 0,
        widthGallerie: 0,
        tempKeyGall: null,
        tempStateLike: null
    }

    componentDidMount() {
        document.title = "Accueil - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        this.props.handleMenu(false);
        let hash = window.location.hash;
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                setTimeout(() => {
                    this.props.handleMenu(false);
                    element.scrollIntoView({behavior: 'smooth'});
                }, 100);
            }
        }
        setInterval(() => {
            hash = window.location.hash;
            if (hash) {
                const element = document.getElementById(hash.substring(1));
                if (element) {
                    setTimeout(() => {
                        this.props.handleMenu(false);
                        element.scrollIntoView({behavior: 'smooth'});
                    }, 100);
                }
            }
        }, 5000);


        if (this.props.canContinue) {
            this.props.getGallerie();
            this.setState({
                alert: tempAlWait()
            });
        }

        if (localStorage.getItem('galerie') != undefined && localStorage.getItem('galerie') != null) {
            this.setState({
                gallImgs: JSON.parse(localStorage.getItem('galerie'))
            })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.canContinue != this.props.canContinue) {
            if (this.props.canContinue) {
                this.props.getGallerie();
                this.setState({
                    alert: tempAlWait()
                });
            }
        }
        
        if (
            prevProps.redGetGall != this.props.redGetGall &&
            (
                (localStorage.getItem('galerie') != undefined &&
                localStorage.getItem('galerie') != null) &&
                this.props.redGetGall.datas != JSON.parse(localStorage.getItem('galerie'))
            )
        ) {
            this.setState({
                alert: this.props.redGetGall.alert,
                gallImgs: this.props.redGetGall.datas
            });
            this.setState({widthGallerie: document.getElementById('gallerie').clientWidth - document.querySelector('.home__gallerie__gall').clientWidth});
        }
        if (prevProps.redLikeGall != this.props.redLikeGall) {
            if (this.props.redLikeGall.alert.type == "succ") {
                let tempGallerie = this.state.gallImgs;
                if (this.state.tempStateLike == "like") {
                    tempGallerie[this.state.tempKeyGall].isLike = true;
                    tempGallerie[this.state.tempKeyGall].nbLike += 1;
                } else {
                    tempGallerie[this.state.tempKeyGall].isLike = false;
                    tempGallerie[this.state.tempKeyGall].nbLike -= 1;
                }
                this.setState({
                    alert: this.props.redLikeGall.alert,
                    gallImgs: tempGallerie
                })
            } else {      
                this.setState({
                    alert: this.props.redLikeGall.alert
                })
            }
        }
    }

    handleGallerie(dir) {
        let ecart = Math.round(this.state.widthGallerie / 6);
        if (dir == "left") {
            if (this.state.currentPlacementGallerie == 0) {
                this.setState({currentPlacementGallerie: this.state.currentPlacementGallerie});
            } else {
                this.setState({currentPlacementGallerie: this.state.currentPlacementGallerie + ecart});
            }
        } else {
            if (
                this.state.currentPlacementGallerie * -1 > (this.state.widthGallerie - 10) &&
                this.state.currentPlacementGallerie * -1 < (this.state.widthGallerie + 10)
            ) {
                this.setState({currentPlacementGallerie: this.state.currentPlacementGallerie});
            } else {
                this.setState({currentPlacementGallerie: this.state.currentPlacementGallerie - ecart});
            }
        }
    }

    render() {
        return <main className="main home__main">
            {/** Présentation **/}
            <section className="home__pres" style={{backgroundImage: `url('${imgBg}')`}}>
                <article className="pres">
                    <h1 className="pres__ttl">Bienvenue chez {this.props.idtt.name} !</h1>
                    <p className="pres__desc">
                        {this.props.idtt.name}, votre source ultime pour tout ce qui concerne les parcs d'attractions. <br />
                        Plongez dans un monde d'aventure palpitantes, de découvertes fascinantes et de divertissement sans fin.
                    </p>
                    <div className="pres__defile">
                        <div className="pres__def">
                            <span className="pres__deftext">Découvrez Maintenant</span>
                            <span className="pres__deftext">Découvrez Maintenant</span>
                        </div>
                    </div>
                </article>
            </section>
            {/** A propos **/}
            <section className="home__apropos" id="a-propos">
                <article className="home__apropos__zone">
                    <h2 className="home__apropos__ttl">A propos</h2>
                    <p className="home__apropos__desc">
                        {this.props.idtt.name} est le fruit de la passion d'un créateur de contenu dédié aux parcs d'attractions. Ce site offre une collection exclusive de vidéo captivantes, d'articles richement illustrés et des actualités passionnantes. Préparez-vous à plonger dans un univers où le divertissement rencontre l'information.
                    </p>
                </article>
                <div className="home__apropos__illu" style={{backgroundImage: `url('${imgBg2}')`}}></div>
            </section>
            {/** Gallerie **/}
            <section className="home__gallerie" id="galerie">
                <h2 className="home__gallerie__ttl">Galerie</h2>
                <div className="home__gallerie__gall">
                    <div className="home__gallerie__galldef" id="gallerie" data-nb={this.state.gallImgs.length} style={{left: this.state.currentPlacementGallerie + "px"}}>
                        {
                            this.state.gallImgs.map((item, key) => {
                                return <div className="home__gallerie__btnimg" key={`gall-${key}`} data-img={key} style={{backgroundImage: `url('${getDomain()}image/gallerie/${item.img}')`}} title={item.desc} aria-label={item.desc}>
                                    <div className="home__gallerie__transp"></div>
                                    <button
                                        className={`home__gallerie__like ${item.isLike && "home__gallerie__like--islike"}`}
                                        title={item.isLike ? "Je n'aime plus la photo" : "J'aime la photo"}
                                        aria-label={item.isLike ? "Je n'aime plus la photo" : "J'aime la photo"}
                                        onClick={() => {
                                            if (localStorage.getItem('userId') == undefined || localStorage.getItem('userCred') == undefined) {
                                                window.location.href = "./login";
                                            } else {
                                                this.props.likeGallerie({gallId: item.id});
                                                this.setState({
                                                    alert: tempAlWait(),
                                                    tempKeyGall: key,
                                                    tempStateLike: item.isLike ? "dislike" : "like"
                                                })
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faHeart} />
                                        <span className="home__gallerie__likenb">
                                            {item.nbLike == 0 ? "" : item.nbLike}
                                        </span>
                                    </button>
                                </div>
                            })
                        }
                    </div>
                    {/** Boutons **/}
                    <button className={`home__gallerie__btndir ${this.state.currentPlacementGallerie == 0 && "home__gallerie__btndir--inactive"}`} onClick={() => this.handleGallerie("left")}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    <button className={`
                        home__gallerie__btndir
                        ${
                            this.state.currentPlacementGallerie * -1 > (this.state.widthGallerie - 10) &&
                            this.state.currentPlacementGallerie * -1 < (this.state.widthGallerie + 10) &&
                            "home__gallerie__btndir--inactive"
                        }
                    `} onClick={() => this.handleGallerie("right")} id="btn-gallerie-right">
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </div>
            </section>
            <Alert alert={this.state.alert}/>
        </main>
    }
}

const mapStateToProps = state => {
    return {
        redGetGall: state.redGetGall,
        redLikeGall: state.redLikeGall
    }
}

const mapDispatchToProps = {
    getGallerie,
    likeGallerie
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);

/** todo : vérifier les likes **/